<template>
  <b-modal
    ref="modalEMT"
    size="lg"
    dialog-class="!max-w-[500px]"
    body-class="!p-[16px]"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    hide-header
  >
    <h4 class="text-center text-[20px] font-semibold mt-[16px] mb-[24px] text-black">
      ⚠️ Hubungkan Ulang Toko Anda
    </h4>

    <p>Terdapat {{ totalStores }} toko yang belum terhubung dengan Kompack, yuk hubungkan sekarang agar orderan kamu tetap lancar!</p>

    <ol class="list-decimal pl-[16px] mt-[8px] mb-[20px] overflow-y-auto max-h-[400px]">
      <li
        v-for="(store, index) in data.stores"
        :key="store.shop_id"
        class="mb-[12px]"
      >
        <div>
          <h4 class="text-[#333333] text-[16px] font-semibold">
            {{ store.shop_name }}
          </h4>
          <span class="mb-[3px] block">Berakhir pada {{ displayTime(store.authentication_expired_at) }}</span>
          <b-button
            variant="primary"
            size="sm"
            class="!flex items-center justify-center gap-[8px]"
            :disabled="isMutating[index]"
            @click="handleReauthenticate(index, store)"
          >
            <b-spinner
              v-if="isMutating[index]"
              small
              variant="white"
            />
            Hubungkan Sekarang
          </b-button>
        </div>
      </li>
    </ol>

    <div class="flex flex-row gap-[16px]">
      <b-button
        variant="outline-primary"
        class="w-full"
        @click="handleCancel"
      >
        Nanti Dulu
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { FULL_DATE_TIME } from '@/libs/formatDate'

export default {
  name: 'ModalExtendMarketplaceToken',
  data() {
    return {
      data: [],
      isMutating: [],
      isSuccess: [],
    }
  },
  computed: {
    totalStores() {
      return this.data?.stores?.length || ''
    },
  },
  watch: {
    totalStores(newVal) {
      if (newVal > 0) {
        this.isMutating = Array(newVal).fill(false)
        this.isSuccess = Array(newVal).fill(false)
      }
    },
  },
  methods: {
    /**
     * Tampilkan modal extend marketplace token dan set data toko
     * @param {Object} data - data toko dengan token kedaluwarsa
     * @param {Array} data.stores - daftar toko yang tokennya kedaluwarsa
     */
    show(data) {
      this.data = data

      this.$nextTick(() => {
        if (this.$refs.modalEMT) {
          this.$refs.modalEMT.show()
        }
      })
    },
    /**
     * Sembunyikan modal dan reset state isMutating
     */
    hide() {
      this.isMutating = []
      this.data = []
      this.$refs.modalEMT.hide()
    },

    /**
     * Format waktu kedaluwarsa token untuk ditampilkan
     * @param {string|null} time - ISO string waktu kedaluwarsa
     * @returns {string} waktu terformat atau '-' jika kosong
     */
    displayTime(time) {
      if (!time) return '-'
      return FULL_DATE_TIME(time)
    },
    /**
     * Trigger proses reauthentikasi untuk satu toko.
     * Jika reauthentikasi berhasil, update status isSuccess dan sembunyikan modal jika semua toko sudah berhasil direauthentikasi.
     * @param {number} index - indeks toko dalam daftar
     * @param {Object} store - data toko yang akan direauthentikasi
     * @param {string} store.marketplace - nama marketplace
     * @param {string} store.shop_id - ID toko
     */
    handleReauthenticate(index, store) {
      this.$set(this.isMutating, index, true)

      this.$emit('reauthenticate', {
        marketplace: store.marketplace,
        shop_id: store.shop_id,
        statusCb: completed => {
          this.$set(this.isMutating, index, false)

          if (completed) {
            this.$set(this.isSuccess, index, true)

            this.$nextTick(() => {
              if (this.isSuccess.every(status => status)) {
                this.hide()
              }
            })
          }
        },
      })
    },
    handleCancel() {
      this.hide()
    },
  },
}
</script>
